<div mat-dialog-content>
    <h1 mat-dialog-title>User Not Authorized</h1>
</div>